import { getPropsForClickTracking } from "../../utils/tracking";
import { t } from "@ebay/i18n-ebay";

<if(input.locateMe)>
  <div class="map-locate-me map-component-with-tooltip">
    <span class="map-component-tooltip">
      <fe-textual-display model=t("mapview/map", "locateMeTooltipLabel")/>
    </span>
    <ebay-icon-button
      data-testid="locate-me-button"
      on-click("onCtaClick")
      aria-label=(input.locateMe.accessibilityText)
      title=(input.locateMe.accessibilityText)
      disabled=input.disabled
      ...getPropsForClickTracking(input.locateMe?.action?.trackingList)
    >
      <ebay-location-arrow-16-icon/>
    </ebay-icon-button>
  </div>
</if>
